import React from "react";
import "./headerHL.css";


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const HeaderHLPure = (props) => {
  const { title, subtitleActive, subtitleText, headingNumber = 1, style } = props;

  const CustomHeadingTag = `h${headingNumber}`;

  return (
    <div className={`headerHLPure-container ${subtitleActive ? "" : "no-subtitle"}`}>
      <div className="headerHLPure-titleContainer">
        <CustomHeadingTag style={style} className="headerHLPure-titleText ellipsis">{title}</CustomHeadingTag>
      </div>
      {subtitleActive !== false ? (
        <div className="headerHLPure-subtitleContainer">
          <p className="headerHLPure-subtitleText ellipsis">{subtitleText}</p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export { HeaderHLPure as default };
